import { getTenantFromHostname } from "@/utils/get-tenant-from-hostname";
import { VideoControllerApi } from "../../services";
import { getConfigObject } from "../../utils/utils";

/**
 * Fetch a Zoom Video SDK signature for the given room.
 * Reuses /api/master/token/{room} — same endpoint used by the legacy flow.
 */
export async function fetchSessionSignature(
  room: string,
  isPublicView: boolean
): Promise<string> {
  const xTENANTID = getTenantFromHostname();
  const api = new VideoControllerApi(
    isPublicView ? undefined : getConfigObject()
  );
  const res: any = await api.getAuthToken(room, undefined, xTENANTID);
  // The backend wraps the JWT under data.data.authToken — same shape the
  // legacy /zoom/Preview.tsx flow reads. Fall back to other plausible field
  // names so a backend rename doesn't break the new flow silently.
  const inner = res?.data?.data ?? res?.data ?? res;
  if (typeof inner === "string") return inner;
  return (
    inner?.authToken ??
    inner?.accessToken ??
    inner?.signature ??
    inner?.token ??
    inner?.sdkToken ??
    ""
  );
}
